import React, { useState, useEffect, useReducer, useCallback, useMemo } from "react";
import APIService from "../../Services/API/APIService";
import {
  Table,
  Dimmer,
  Loader,
  Menu,
  Form,
  Modal,
  Label,
  Pagination,
  Input,
  Button,
  Dropdown

} from "semantic-ui-react";
import numeral from "numeral";
import ProductTypes from "../../Data/ProductTypes";
import ViewActivity from "./ViewActivity";
import { sortReducer } from "../../utils/SortReducer";
import moment from "moment";
import { toast } from "react-toastify";

const MonthlyRecords = (props) => {
  const [loading, setLoading] = useState(false);
  const [searchPhrase, setSearchPhrase] = useState(null);
  const [selectActivity, setSelectedActivity] = useState([])
  const [activityModalState, toggleActivityModal] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
  const [state, dispatch] = useReducer(sortReducer, {
    column: null,
    data: null,
    direction: null,
  });

  const { data } = state;
  const [offset, setOffset] = useState(0);
  const [limit] = useState(50);
  const [rowCount, setRowCount] = useState(0);

  let query = useMemo(() => {
    return {
      offset: offset,
      limit: limit,
      startDate: startDate,
      endDate: endDate
    }
  }, [limit, offset, startDate, endDate])

  const fetchData = useCallback(async (isSubscribed) => {
    try {
      setLoading(true);
      let result = await APIService.getData("/analytics/GuestHouseMonthlyReport", {
        ...query
      })
      dispatch({
        type: "",
        column: "",
        payload: result.response,
      });
      if (isSubscribed) {
        setRowCount(result.count)
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [query])

  useEffect(() => {
 let isSubscribed = true
    fetchData(isSubscribed);

    return () => (isSubscribed = false)

  }, [offset, fetchData]);

  const _searchChanged = (e) => {
    setSearchPhrase(e.target.value);
  };

  const _search = async () => {
    setLoading(true);
    try {
      let result = [];
      if (searchPhrase) {
        result = await APIService.getData(`/analytics/searchGuestHouseMonthlyReport`, {
          name: searchPhrase,
          startDate: startDate,
          endDate: endDate
        });
      }
      setLoading(false);

      dispatch({
        type: "",
        column: "",
        payload: result.response,
      });

      setRowCount(result.count)

    } catch (error) {
      setLoading(false);
      toast.warn(error)
    }
  };

  const viewActivity = async (booking) => {
    try {
      setSelectedActivity(booking);
      toggleActivityModal(true);
    } catch (error) {
      console.log("error", error);
    }
  };


  let counter = 0

  let bookingItems = data?.map((item,index) => (

    <Table.Row key={index}>

      <Table.Cell>   {counter = counter + 1} </Table.Cell>

      <Table.Cell>   {item.secretFirstname ? item.secretFirstname + " " + item.secretLastname : item.firstname + " " + item.lastname} </Table.Cell>

      <Table.Cell>   {item.group} </Table.Cell>
      <Table.Cell> {item.RoomtotalNights || 0}</Table.Cell>

      <Table.Cell>
        ₦
        {
          numeral(item.RoomTotal).format("0,0")
        }

      </Table.Cell>
      <Table.Cell>
        ₦
        {
          numeral(item.RoomDiscount).format("0,0")
        }

      </Table.Cell>

      <Table.Cell>
        ₦
        {
          numeral(item.FoodTotal).format("0,0")

        }
      </Table.Cell>
      <Table.Cell>
        ₦
        {
          numeral(item.BeverageTotal).format("0,0")
        }
      </Table.Cell>
      <Table.Cell>
        ₦
        {
          numeral(item.LaundryTotal).format("0,0")

        }
      </Table.Cell>

      <Table.Cell>
        ₦ {numeral(Number(item.RoomTotal || 0) + Number(item.BeverageTotal || 0) +
          Number(item.LaundryTotal || 0) + Number(item.FoodTotal || 0) - Number(item.RoomDiscount || 0)).format("0,0")

        }
      </Table.Cell>

      <Table.Cell>
        <Dropdown icon="ellipsis vertical" fluid floating pointing="bottom right">
          <Dropdown.Menu>



            <Dropdown.Item
              icon="elementor"
              text="View Activity"
              onClick={() => viewActivity({
                GuestHouseUserId: item.GuestHouseUserId,
                checkin: startDate,
                checkout: endDate,
                id: item.GuestHouseBookingId,
              })}
            />

          </Dropdown.Menu>
        </Dropdown>
      </Table.Cell>


    </Table.Row>
  ))

  const handleExcel = async (url, file) => {
    try {
      await APIService.downloadfile(url, {
        fileName: file,
        startDate: startDate,
        endDate: endDate,
        productTypeId: ProductTypes.GUESTHOUSE.id

      }

      )

      toast.success('Completed')

    } catch (error) {
      toast.warn(error)
    }
  }


  return (

    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}

      <Menu secondary stackable>

        <Button onClick={() => fetchData(true)} color="teal" >  View Report</Button>
        <Button onClick={() => handleExcel('/analytics/CooperatorMonthlyReport', 'CooperatorMonthlyReport.xlsx')} color="teal">  Download Cooperator Report</Button>

        <Menu.Menu position="right">

          <Menu.Item>

            <Label color="teal" > startDate</Label>
            <Input
              type="date"
              name="startDate"
              onChange={(e) => setStartDate(e.target.value)}
              value={startDate}
              min='2020-01-01'
              max='2050-12-31'
            />
            <Label color="blue" > endDate</Label>
            <Input

              type="date"
              name="endDate"
              onChange={(e) => setEndDate(e.target.value)}
              value={endDate}

              min='2020-01-01'
              max='2050-12-31'
            />

          </Menu.Item>
          <Menu.Item>
            <Form>
              <Form.Input
                placeholder="firstname or lastname"
                icon="search"
                onChange={_searchChanged}
                action={{
                  onClick: _search,
                  color: 'teal'
                }}

              />
            </Form>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      {data && (
        <Table striped stackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>S/N</Table.HeaderCell>
              <Table.HeaderCell>Customer</Table.HeaderCell>
              <Table.HeaderCell>Group</Table.HeaderCell>
              <Table.HeaderCell>No of Nights</Table.HeaderCell>
              <Table.HeaderCell>Room Total</Table.HeaderCell>
              <Table.HeaderCell>Room Discount</Table.HeaderCell>
              <Table.HeaderCell>Food  Total </Table.HeaderCell>
              <Table.HeaderCell>Beverages Total </Table.HeaderCell>

              <Table.HeaderCell>Laundry Total</Table.HeaderCell>
              <Table.HeaderCell> Total </Table.HeaderCell>


              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{bookingItems}</Table.Body>
        </Table>
      )}



      <Modal
        size="large"
        open={activityModalState}
        onClose={() => toggleActivityModal(false)}
        closeIcon
      >
        <Modal.Header>View Activity</Modal.Header>
        <Modal.Content>

          <ViewActivity selectActivity={selectActivity} />
        </Modal.Content>
      </Modal>


      <Pagination
        defaultActivePage={1}
        totalPages={Math.ceil(rowCount / limit)}
        onPageChange={(e, { activePage }) =>
          setOffset(1 + (activePage - 1) * limit)
        }
      />

    </div>


  );
};

export default MonthlyRecords